import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string()
    .email('Email is invalid')
    .required('Email is required'),
  firstName: Yup.string()
    .when('$collectTesterName', {
      is: false,
      then: Yup.string(),
      otherwise: Yup.string().required('First name is required'),
    }),
  lastName: Yup.string()
    .when('$collectTesterName', {
      is: false,
      then: Yup.string(),
      otherwise: Yup.string().required('Last name is required'),
    }),
});
